
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Detail extends Vue {
  private radio = 'projectList'

  created () {
    this.radio = this.$route.path.substr(this.$route.path.lastIndexOf('/') + 1)
  }

  handleChange () {
    const path = `/resource/${this.radio}`
    this.$router.replace({ path: path })
  }
}
